import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

let nextId = 0;

/**
 * A settings card: an h2 heading with an optional description, optional
 * `[sectionActions]` on the right, then projected `app-settings-row-cabinet`
 * rows. `danger` is the Danger Zone look for destructive actions.
 */
@Component({
  selector: 'app-settings-section-cabinet',
  templateUrl: './settings-section.component.html',
  styleUrl: './settings-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  host: {
    '[class.settings-section--danger]': "tone() === 'danger'",
  },
})
export class SettingsSectionCabinetComponent {
  readonly heading = input.required<string>();
  readonly description = input<string>('');
  readonly tone = input<'default' | 'danger'>('default');

  readonly headingId = `settings-section-${nextId++}`;
}
